<template>
  <div class="backgroudColor">
    <el-row class="content">
      <el-col :span="24" style="margin-top:30px;">
        <el-row class="persionMsg">
          <el-col :span="2" class="titleBack">
            <img src="@/assets/pcImage/rainbowLoginLogo2x.png" />
          </el-col>
          <el-col :span="13" style="line-height:40px;margin-left:20px">
            <span>姓名啊</span>
            <span class="fenge"></span>
            <span>职位</span>
          </el-col>

          <el-col :span="8" style="line-height:40px;text-align:right">
            <img src="@/assets/pcImage/icon/buleStart.png" style="margin-bottom: -3px;" />
            <span style="color:#f82b18;font-size:14px;font-weight:400;padding-left:5px">收藏了您</span>
          </el-col>
        </el-row>

        <el-row class="persionMsg descBackGroud">
          <el-col :span="22">
            <el-row>
              <el-col :span="19" style="line-height:40px;">
                <span style="margin-left: 30px;">职位名称</span>
                <span style="margin-left:20px">2000-3000</span>
              </el-col>
              <el-col :span="5" style="line-height:40px;">
                <span>北京奥德赛分公司</span>
              </el-col>
            </el-row>

            <el-row style="line-height:30px;font-size:12px;color:#888">
              <el-col :span="15">
                <span style="margin-left: 30px;">经验1-3年</span>
                <span class="fenge"></span>
                <span style>大专学历</span>
                <span class="fenge"></span>
                <span style>大专学历</span>
              </el-col>
              <el-col :span="8" style="text-align:right;margin-left:6px">
                <span>肢体受损</span>

                <span class="fenge"></span>
                <span style>听力受损</span>
                <span class="fenge"></span>
                <span style>视力受损</span>
              </el-col>
            </el-row>
          </el-col>

          <el-col :span="2" style="height:74px;">
            <img
              src="@/assets/pcImage/rainbowLoginLogo2x.png"
              style="width:50px;
height:50px;
border-radius:6px;
vertical-align: middle;"
            />
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ResumeTitle from "@/components/ResumeTitle.vue";
export default {
  name: "UsersResume",
  components: {
    ResumeTitle
  },
  props: {
    msg: String
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.titleBack {
  // background: rgba(246, 246, 248, 1);
  img {
    margin-left: 33px;
    width: 40px;
    height: 40px;
    border-radius: 40px;
  }
}

.fenge {
  margin: 0 10px;
  border-right: 2px solid #dddddd;
  line-height: 10px;
}

.persionMsg {
  // background: rgba(255, 255, 255, 1);
  height: 110%;
  width: 860px;
}

.descBackGroud {
  height: 74px;
  background: rgba(247, 247, 247, 1);
  border-radius: 6px;
  margin-top: 20px;
  width: 759px;
  margin-left: 90px;
  line-height: 74px;
}

.persionMsg div {
  text-align: left;

  .fromLabelFont >>>.el-form-item__label {
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 24px;
  }
}

.content {
  font-size: 14px;
  text-align: right;
  width: 1200px;
  margin: 0 auto;
}

.backgroudColor {
  // background-color: rgba(246, 246, 248, 1);
  // background: rgba(125, 203, 220, 1);
  width: 100%;
  height: 180px;

  .descFont {
    height: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #888;
    line-height: 24px;
  }

  .companyName {
    width: 104px;
    height: 26px;
    font-size: 26px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 39px;
  }

  .helpPeople {
    width: 49px;
    height: 24px;
    font-size: 24px;
    font-weight: 500;
    color: #f82b18;
    line-height: 36px;
  }

  .positionNum {
    width: 160px;
    height: 26px;
    font-size: 26px;
    font-weight: 500;
    color: #f82b18;
    line-height: 39px;
    display: block;
    text-align: center;
  }

  .fastPosition {
    width: 164px;
    height: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #888;
    line-height: 24px;
    display: block;
    text-align: center;
  }
}
</style>
